// Validación de emails alineada con functions/src/extractEmail.js.
// Se usa en el frontend para ocultar/filtrar emails no funcionales que
// puedan haber quedado guardados antes de aplicar el saneamiento en backend.

const ASSET_TLDS = new Set([
    'png', 'jpg', 'jpeg', 'gif', 'webp', 'svg', 'ico', 'bmp', 'tif', 'tiff',
    'avif', 'heic', 'heif',
    'js', 'mjs', 'cjs', 'css', 'scss', 'sass', 'less',
    'woff', 'woff2', 'ttf', 'otf', 'eot',
    'map', 'json', 'xml', 'yaml', 'yml',
    'pdf', 'zip', 'rar', '7z', 'tar', 'gz',
    'mp3', 'mp4', 'wav', 'ogg', 'webm', 'mov', 'avi', 'wmv', 'flv', 'mkv',
    'html', 'htm', 'php', 'aspx', 'jsp',
    'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx',
]);

const BLOCKED_DOMAINS = new Set([
    'sentry.io',
    'sentry-next.wixpress.com',
    'wixpress.com',
    'wix.com',
    'example.com',
    'example.org',
    'example.net',
    'domain.com',
    'email.com',
    'test.com',
    'yoursite.com',
    'yourdomain.com',
    'yourwebsite.com',
    'mysite.com',
    'site.com',
    'mail.com',
]);

export function isValidBusinessEmail(email) {
    if (!email || typeof email !== 'string') return false;
    const lower = email.toLowerCase().trim();

    const parts = lower.split('@');
    if (parts.length !== 2) return false;
    const [user, domain] = parts;
    if (!user || !domain) return false;
    if (user.length > 64 || domain.length > 253) return false;

    if (!/[a-z]/.test(user)) return false;

    if (!domain.includes('.')) return false;
    if (/^[.-]|[.-]$/.test(domain)) return false;
    if (/\.\./.test(domain)) return false;

    // Evita casos tipo nuvempago@2x.png
    if (/@\d+x?\.(png|jpe?g|gif|webp|svg|ico|bmp|avif|heic)/i.test(lower)) return false;
    if (/\.(png|jpe?g|gif|webp|svg|ico|bmp|avif|heic)$/i.test(user)) return false;

    const tldMatch = domain.match(/\.([a-z0-9-]{2,24})$/i);
    if (!tldMatch) return false;
    const tld = tldMatch[1].toLowerCase();
    if (ASSET_TLDS.has(tld)) return false;
    if (/^\d+$/.test(tld)) return false;

    if (BLOCKED_DOMAINS.has(domain)) return false;

    if (/\.(png|jpe?g|gif|webp|svg|ico|bmp|avif|heic|js|css|woff2?|ttf|map)(\.|$)/i.test(domain)) {
        return false;
    }

    return true;
}

// Devuelve el email si es válido, o '' para que la UI lo trate como vacío.
export function sanitizeEmail(email) {
    return isValidBusinessEmail(email) ? email.toLowerCase().trim() : '';
}
